// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const sektion = document.querySelector('.produkt-sida');
  if (!sektion) return;

  const galleri    = sektion.querySelector('[data-modal-galleri]');
  const modal      = sektion.querySelector('.produkt-sida__modal');
  const modalBild  = sektion.querySelector('.produkt-sida__modal-bild');
  const infoKol    = sektion.querySelector('.produkt-sida__info');
  const pdpIndex   = sektion.querySelector('[data-pdp-kortindex]');

  const reducerad  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const galleriBilder = galleri ? Array.from(galleri.querySelectorAll('.produkt-sida__bild')) : [];
  const totalBilder   = galleriBilder.length;

  const arMobil = () => window.matchMedia('(max-width: 900px)').matches;

  let mobilAktivIndex = 0;

  const visaMobilBild = (index) => {
    const i = ((index % totalBilder) + totalBilder) % totalBilder;
    mobilAktivIndex = i;
    galleriBilder.forEach((b, n) => {
      b.dataset.state = n === i ? 'aktiv' : '';
    });
    if (pdpIndex) pdpIndex.textContent = `${i + 1} / ${totalBilder}`;
  };

  const initMobil = () => {
    if (!arMobil() || totalBilder === 0) return;
    visaMobilBild(0);
  };

  initMobil();
  window.matchMedia('(max-width: 900px)').addEventListener('change', (e) => {
    if (e.matches) {
      initMobil();
    } else {
      galleriBilder.forEach((b) => { b.dataset.state = ''; });
    }
  });

  let lenisGalleri = null;

  const skapLenis = (wrapper) => {
    if (!wrapper || reducerad || !window.Lenis) return null;
    const lenis = new window.Lenis({
      wrapper,
      content: wrapper,
      orientation: 'vertical',
      smoothWheel: true,
      syncTouch: false,
    });
    const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    return lenis;
  };

  if (!arMobil()) {
    if (galleri)  lenisGalleri = skapLenis(galleri);
    if (infoKol)  skapLenis(infoKol);
  }

  let modalAktivIndex = 0;

  const oppnaModal = (index) => {
    if (!modal || totalBilder === 0) return;
    const i = ((index % totalBilder) + totalBilder) % totalBilder;
    modalAktivIndex = i;
    const lank = galleriBilder[i];
    if (!lank) return;
    modalBild.src = lank.href;
    modalBild.alt = lank.getAttribute('aria-label') || '';
    modal.removeAttribute('hidden');
    requestAnimationFrame(() => { modal.dataset.state = 'oppen'; });
    modal.querySelector('[data-action="modal/stang"]')?.focus();
  };

  const stangModal = () => {
    if (!modal) return;
    modal.dataset.state = 'stangd';
    modal.addEventListener('transitionend', () => {
      modal.setAttribute('hidden', '');
    }, { once: true });
  };

  const modalNavigera = (riktning) => {
    oppnaModal(modalAktivIndex + riktning);
  };

  document.addEventListener('click', (e) => {
    const bildlank = e.target.closest('[data-action~="galleri/modal"]');
    if (bildlank && !arMobil()) {
      e.preventDefault();
      const index = parseInt(bildlank.dataset.galleriIndex || '0', 10);
      oppnaModal(index);
      return;
    }

    const action = e.target.closest('[data-action]')?.dataset.action;

    if (action === 'modal/stang') { stangModal(); return; }
    if (action === 'modal/fore')  { modalNavigera(-1); return; }
    if (action === 'modal/nasta') { modalNavigera(1);  return; }

    if (arMobil()) {
      if (action === 'kortbild/fore')  { visaMobilBild(mobilAktivIndex - 1); return; }
      if (action === 'kortbild/nasta') { visaMobilBild(mobilAktivIndex + 1); return; }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (!modal || modal.dataset.state !== 'oppen') return;
    if (e.key === 'Escape')     stangModal();
    if (e.key === 'ArrowLeft')  modalNavigera(-1);
    if (e.key === 'ArrowRight') modalNavigera(1);
  });

  let swipeStartX = 0;
  const SWIPE_TROSKEL = 40;

  if (galleri) {
    galleri.addEventListener('touchstart', (e) => {
      swipeStartX = e.touches[0].clientX;
    }, { passive: true });

    galleri.addEventListener('touchend', (e) => {
      if (!arMobil()) return;
      const delta = e.changedTouches[0].clientX - swipeStartX;
      if (Math.abs(delta) < SWIPE_TROSKEL) return;
      delta < 0 ? visaMobilBild(mobilAktivIndex + 1) : visaMobilBild(mobilAktivIndex - 1);
    }, { passive: true });
  }

  const scrollaTillBild = (index) => {
    if (!galleri) return;
    if (arMobil()) {
      visaMobilBild(index);
      return;
    }
    const mal = galleri.querySelector(`[data-galleri-index="${index}"]`);
    if (!mal) return;
    if (lenisGalleri) {
      lenisGalleri.scrollTo(mal, { offset: 0, immediate: false });
    } else {
      mal.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const info = sektion.querySelector('.produkt-sida__info');
  const form = sektion.querySelector('.produkt-sida__form');
  const varianterJson = sektion.querySelector('[data-produkt-varianter]');
  const tillstand = { tillganglig: 'tillganglig', slutsald: 'slutsald', ogiltig: 'ogiltig' };
  let uppdateraVariant = null;

  if (form && varianterJson && info) {
    let alternativ = [];
    let varianter = [];
    try {
      const data = JSON.parse(varianterJson.textContent);
      alternativ = (data.alternativ ?? []).filter(Boolean);
      varianter = data.varianter ?? [];
    } catch (_) { alternativ = []; varianter = []; }

    if (varianter.length && alternativ.length) {
      const idInput = form.querySelector('[name="id"]');
      const prisEl = sektion.querySelector('.produkt-sida__pris');
      const jamforprisEl = sektion.querySelector('.produkt-sida__jamforpris');
      const knapp = form.querySelector('[data-action~="varukorg/lagg-till"]');

      const hamtaValdaAlternativ = () => alternativ.map((n) => form.querySelector(`input[name="${CSS.escape(n)}"]:checked`)?.value ?? null);

      const matcharDelvis = (variant, valda, index, varde) => variant.options.every((opt, i) => {
        const v = i === index ? varde : valda[i];
        return v == null || opt === v;
      });

      const finnsKombination = (valda, index, varde) => varianter.some((v) => matcharDelvis(v, valda, index, varde));

      const hittaVariant = (valda) => {
        if (valda.some((v) => v == null)) return null;
        return varianter.find((v) => v.options.every((opt, i) => opt === valda[i])) ?? null;
      };

      const uppdateraTillganglighet = (valda) => {
        form.querySelectorAll('.produkt-sida__alternativ-radio').forEach((radio) => {
          const index = alternativ.indexOf(radio.name);
          const label = radio.closest('.produkt-sida__alternativ-val');
          const ok = index === -1 ? true : finnsKombination(valda, index, radio.value);
          radio.disabled = !ok;
          if (label) label.dataset.tillstand = ok ? '' : 'ogiltig';
        });
      };

      const repareraVal = () => {
        let fix = false;
        alternativ.forEach((namn) => {
          const checked = form.querySelector(`input[name="${CSS.escape(namn)}"]:checked`);
          if (checked && !checked.disabled) return;
          const fallback = form.querySelector(`input[name="${CSS.escape(namn)}"]:not(:disabled)`);
          if (fallback && fallback !== checked) {
            fallback.checked = true;
            fix = true;
          }
        });
        return fix;
      };

      const sattTillstand = (nytt) => {
        info.dataset.tillstand = nytt;
        if (knapp) {
          knapp.disabled = nytt !== tillstand.tillganglig;
          knapp.setAttribute('aria-disabled', nytt === tillstand.tillganglig ? 'false' : 'true');
        }
      };

      uppdateraVariant = () => {
        let valda = hamtaValdaAlternativ();
        uppdateraTillganglighet(valda);
        if (repareraVal()) {
          valda = hamtaValdaAlternativ();
          uppdateraTillganglighet(valda);
        }
        const variant = hittaVariant(valda);
        if (!variant) {
          info.dataset.valdVariantId = '';
          info.dataset.jamforpris = 'dold';
          if (idInput) idInput.value = '';
          sattTillstand(tillstand.ogiltig);
          return null;
        }
        info.dataset.valdVariantId = String(variant.id);
        info.dataset.jamforpris = variant.compare_at_price > variant.price ? 'visas' : 'dold';
        if (idInput) idInput.value = String(variant.id);
        if (prisEl) prisEl.textContent = variant.price_formatted;
        if (jamforprisEl) jamforprisEl.textContent = variant.compare_at_price_formatted;
        sattTillstand(variant.available ? tillstand.tillganglig : tillstand.slutsald);
        return variant;
      };

      form.synkaValdVariant = uppdateraVariant;
      form.addEventListener('submit', () => { uppdateraVariant(); }, true);
      uppdateraVariant();
    }
  }

  document.addEventListener('change', (e) => {
    const radio = e.target.closest('.produkt-sida__alternativ-radio');
    if (!radio || !sektion.contains(radio)) return;
    const variant = uppdateraVariant?.();
    const index = variant?.featured_image_index ?? radio.dataset.variantBildIndex;
    if (index != null && index !== '') scrollaTillBild(Number(index));
  });
})();
